export const session = {
    get(key) {
        return JSON.parse(localStorage.getItem(key));
    },

    set(key, payload) {
        localStorage.setItem(key, JSON.stringify(payload));
        
        return new Promise((resolve, reject) => {
            resolve();
        });
    },

    getSessionToken() {
        return this.get('session_token');
    },

    clearAuth() {
        localStorage.removeItem('session_token');
        localStorage.removeItem('session_expiry');
        localStorage.removeItem('user_data');
        localStorage.removeItem('user_type');
    }
}